import VMasker from 'vanilla-masker'

const formatCpf = (cpf = '') => {
  return VMasker.toPattern(cpf, '999.999.999-99')
}

export default formatCpf
